import axiosInstance from "./axiosInstance";
import Configs from "../utils/Configs";

const ApiServices = {
  fetchCountries: async () => {
    try {
      const response = await axiosInstance.post(Configs.countriesEp, {});

      if (
        response.data?.status === "success" &&
        Array.isArray(response.data.data)
      ) {
        return response.data.data.map(({ c_cname, c_ccode, c_isotwocode }) => ({
          name: c_cname,
          isoCode: c_isotwocode,
          callingCode: c_ccode,
        }));
      } else {
        throw new Error(
          `Failed to load countries: ${
            response.data?.message || "Unknown error"
          }`
        );
      }
    } catch (error) {
      console.error(
        "Error fetching countries:",
        error.response || error.message
      );
      return [];
    }
  },

  fetchCountryAreas: async (isoCode) => {
    try {
      const response = await axiosInstance.post(Configs.countryAreasEp, {
        isotwo: isoCode,
      });

      if (
        response.data?.status === "success" &&
        Array.isArray(response.data.data)
      ) {
        return response.data.data.map(({ a_areaid, a_city }) => ({
          id: a_areaid,
          name: a_city,
        }));
      } else {
        throw new Error(
          `Failed to load areas: ${response.data?.message || "Unknown error"}`
        );
      }
    } catch (error) {
      console.error(
        "Error fetching country areas:",
        error.response || error.message
      );
      return [];
    }
  },
};

export default ApiServices;
